import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import Home from './Home';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import { ThemeProvider } from '@mui/material';
import { theme } from './generals/theme';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import 'dayjs/locale/de';
import 'dayjs/locale/en';
import 'dayjs/locale/es';
import 'dayjs/locale/fr';
import 'dayjs/locale/it';
import 'dayjs/locale/nl';
import 'dayjs/locale/pt';
import 'date-fns/locale/en-US';
import 'date-fns/locale/de';
import 'date-fns/locale/fr';
import 'date-fns/locale/es';
import 'date-fns/locale/it';
import 'date-fns/locale/nl';
import 'date-fns/locale/pt';
import { getLocale } from './generals/locale';

const root = ReactDOM.createRoot(
    document.getElementById('root') as HTMLElement
);

const router = createBrowserRouter([
    {
        path: '/',
        element: <>
            <Home />
        </>,
    },
    {
        path: '*',
        element: <>
            <Home />
        </>,
    },
]);

root.render(
    <React.StrictMode>
        <ThemeProvider theme={theme}>
            <LocalizationProvider
                dateAdapter={AdapterDayjs}
                adapterLocale={getLocale()}
            >
                <RouterProvider router={router} />
            </LocalizationProvider>
        </ThemeProvider>
    </React.StrictMode>
);
